import leonsbuLogo from './img/leonsbuLogo.png';
import 'animate.css'
import './styles/App.css';
import { BackButton } from './components/BackButton';
import { SocialCardItem } from './components/SocialCardItem';

export function Support () {

    return (
      <div className='App'>
        <img src={leonsbuLogo} className='leonsbu-logo' alt='leonsbu logo' />
            <div className='infobox-1-outer support-box'>
              <div className='back-button-container'>
                <BackButton></BackButton>
              </div>
              <h2>As a full-time student whose main source of income is Minecraft content, any and all support really means the world.</h2>
              <p>🧡 Consider supporting me via Patreon, or a YouTube Membership, for as little as $2 USD a month! 🧡</p>
              <div className='supportButtonsContainer'>
                <SocialCardItem
                  type='main'
                  social='patreon'
                  title=''
                  url='https://www.patreon.com/cw/LeonSBU/'
                />
                <SocialCardItem
                  type='main'
                  social='youtube'
                  title=''
                  url='https://www.youtube.com/channel/UCBDDDPa3UbxbbPIIeeEiHRw/join'
                />
              </div>
              <p>As a supporter, you'll get early access to new videos, with your name in the credits.</p>
              <p>$5+/month supporters will receive the Twitch VIP role, and access to an exclusive channel in my Discord!</p>
              <h3>Thank you! 🧡</h3>
            </div>
      </div>
    )
}